import React, { useState, useEffect } from "react";
import "./App.css";
import SpreadsheetComponent from "./Spreadsheet";
import Dashboard from "./Dashboard";
import DefinedField from "./DefinedField";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { SAMdata, IOdataReal, GovAccountData, ExternalSectorData, FactorIncomeData, HouseholdAccountsData, InstitutionalTransfersData, FinancialAccountsData, MonetaryAccountsData } from "./data";

function App() {
  const [selectedMenu, setSelectedMenu] = useState("spreadsheet");
  const [collapsed, setCollapsed] = useState(false);
  const [panelWidth, setPanelWidth] = useState(250);
  const [isResizing, setIsResizing] = useState(false);

  const handleMouseDown = () => setIsResizing(true);
  const handleMouseUp = () => setIsResizing(false);
  const handleMouseMove = (e) => {
    if (isResizing) {
      const newWidth = Math.max(60, Math.min(e.clientX, 400));
      setPanelWidth(newWidth);
    }
  };

  // Disable browser swipe navigation for entire application
  useEffect(() => {
    const preventSwipeNavigation = (e) => {
      // Prevent swipe gestures that trigger browser navigation
      e.preventDefault();
      e.stopPropagation();
    };

    const preventTouchNavigation = (e) => {
      // Prevent touch gestures that might trigger navigation
      e.preventDefault();
      e.stopPropagation();
    };

    const preventGestureNavigation = (e) => {
      // Prevent gesture navigation
      e.preventDefault();
      e.stopPropagation();
    };

    // Add event listeners for the entire document
    document.addEventListener("touchstart", preventTouchNavigation, { passive: false });
    document.addEventListener("touchmove", preventSwipeNavigation, { passive: false });
    document.addEventListener("touchend", preventTouchNavigation, { passive: false });
    document.addEventListener("gesturestart", preventGestureNavigation, { passive: false });
    document.addEventListener("gesturechange", preventGestureNavigation, { passive: false });
    document.addEventListener("gestureend", preventGestureNavigation, { passive: false });

    return () => {
      document.removeEventListener("touchstart", preventTouchNavigation);
      document.removeEventListener("touchmove", preventSwipeNavigation);
      document.removeEventListener("touchend", preventTouchNavigation);
      document.removeEventListener("gesturestart", preventGestureNavigation);
      document.removeEventListener("gesturechange", preventGestureNavigation);
      document.removeEventListener("gestureend", preventGestureNavigation);
    };
  }, []);

  React.useEffect(() => {
    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  });

const renderContent = () => {
  switch (selectedMenu) {
    case "inputoutput":
      return <SpreadsheetComponent initialData={IOdataReal} title="Input-Output Table" />;
    case "sam":
      return <SpreadsheetComponent initialData={SAMdata} title="Macro Social Accounting Matrix for Nepal" />;
    case "gov":
      return <SpreadsheetComponent initialData={GovAccountData} title="Government Accounts Table" />;
    case "external":
      return <SpreadsheetComponent initialData={ExternalSectorData} title="External Sector Table" />;
    case "factor":
      return <SpreadsheetComponent initialData={FactorIncomeData} title="Factor Income Table" />;
    case "household":
      return <SpreadsheetComponent initialData={HouseholdAccountsData} title="Household Accounts Table" />;
    case "transfers":
      return <SpreadsheetComponent initialData={InstitutionalTransfersData} title="Institutional Transfers Table" />;
    case "financial":
      return <SpreadsheetComponent initialData={FinancialAccountsData} title="Financial Accounts Table" />;
    case "monetary":
      return <SpreadsheetComponent initialData={MonetaryAccountsData} title="Monetary Accounts Table" />;
    case "definedfield":
      return <DefinedField />;
    case "dashboard":
    default:
      return <Dashboard />;
  }
};


const menuItems = [
  { key: "dashboard", label: "Dashboard", short: "D" },
  { key: "definedfield", label: "Defined Field", short: "DEF" },
  { key: "inputoutput", label: "Input-Output Matrix", short: "IO" },
  { key: "gov", label: "Government Accounts", short: "GOV" },
  { key: "external", label: "External Sector", short: "EXT" },
  { key: "factor", label: "Factor Income", short: "FAC" },
  { key: "household", label: "Household Accounts", short: "HH" },
  { key: "transfers", label: "Institutional Transfers", short: "TRF" },
  { key: "financial", label: "Financial Accounts", short: "FIN" },
  { key: "monetary", label: "Monetary Accounts", short: "MON" },
  { key: "sam", label: "Social Accounting Matrix", short: "SAM" },
];




  return (
    <div className="app">
      <div
        className={`sidebar ${collapsed ? "collapsed" : ""}`}
        style={{ width: collapsed ? 60 : panelWidth }}
      >
        <button className="collapse-btn" onClick={() => setCollapsed(!collapsed)}>
          {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
        </button>
              {!collapsed && (
  <ul className="menu">
    {menuItems.map((item) => (
      <li
        key={item.key}
        onClick={() => setSelectedMenu(item.key)}
        className={selectedMenu === item.key ? "active" : ""}
      >
        {item.label}
      </li>
    ))}
  </ul>
)}

{collapsed && (
  <ul className="menu">
    {menuItems.map((item) => (
      <li
        key={item.key}
        onClick={() => setSelectedMenu(item.key)}
        title={item.label}
        className={selectedMenu === item.key ? "active" : ""}
      >
        {item.short}
      </li>
    ))}
  </ul>
)}
        <div className="resizer" onMouseDown={handleMouseDown} />
      </div>
      <div className="main">{renderContent()}</div>
    </div>
  );
}

export default App;

